<template>
  <v-card v-if="ies_data && !loading" class="fill-height">
    <DashboardBar :title="ies_data.siglas" :back="false"/>
    <v-list>      
      <v-list-item three-line>
        <v-hover v-slot:default="{ hover }">
          <v-list-item-avatar size="130" tile>
            <v-img 
              max-width="130" 
              max-height="130"
              position="center"
              contain
              :src="`${ies_data.logo}`"
            ></v-img>
            <!--RICK:src="ies_data.logo"-->
            <input 
              type="file"
              accept="image/*"
              id="logo"
              style="display:none"
              @change="changeLogo($event)">
            <v-fade-transition>
              <v-overlay
                v-if="hover"
                absolute
                color="grey"
              >
                <v-btn 
                  small
                  class="mt-2"
                  outlined
                  color="accent"
                  @click="indirectLogo()"
                >
                  Cambiar
                </v-btn>  
              </v-overlay>
            </v-fade-transition>
          </v-list-item-avatar>
        </v-hover>
        <v-list-item-content class="text-left">
          <v-list-item-title
            class="display-2 mb-2 font-weight-bold"
            v-text="ies_data.siglas"
          ></v-list-item-title>
          <v-list-item-subtitle 
            v-text="ies_data.nombre"
            class="headline"
          >
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-subheader class="subtitle-1">Periodos:</v-subheader>
    
    <v-list class="pt-0" three-line min-width="100%" outline>
      <v-divider></v-divider>
      <template 
        v-for="period in periods_ies"
        v-if="period.stage == period.register_referance.stage && 
          hasPreviousYear(period)">
        <v-list-item >
          <v-list-item-content class="text-left">
            <v-list-item-title>
              <span class="display-1 font-weight-bold">{{period.year}} </span>
              <span class="body-1">
                <b>{{period.status_text}}</b>
                ({{period.data_details}})
              </span>
            </v-list-item-title>
            <v-list-item-subtitle class="title">
              {{period.st_detail.message}}
            </v-list-item-subtitle>
          </v-list-item-content>
          <!--            
          <div class="d-lg-inline-flex align-md-content-space-around d-md-flex">-->

          <v-alert type="info" dense tile v-if="needPreviousComplete(period)">
            Antes concluye {{period.year - 1}}
          </v-alert>
          <div v-else-if="period.actions_available < 
                  period.st_detail.available_changes">
            <v-alert type="error" dense>
              Ha expirado el registro
            </v-alert>
          </div>          
          <div 
            v-else
            class="d-flex flex-md-row flex-column width-actions" 
            min-width="240px"
          >
            <v-btn 
              v-if="period.st_detail.can_view_data"
              :outlined="period.st_detail.can_ies_change"
              class="mb-1 mx-1"
              color="accent"
              :to="`/dashboard/period_ies/${period.period_ies_id}`"
            >
              {{period.st_detail.can_ies_change 
                ? 'Modificar Información'
                : 'Ver información'}}
            </v-btn>
            <template v-for="btn in chooseButtons(period)">
              <v-btn 
                class="mb-1 mx-1" 
                color="accent"
                @click="actionButton(btn, period.period_ies_id)"
              >
                {{btn.text}}
              </v-btn>
            </template>
          </div>

        </v-list-item>
        <v-divider></v-divider>
      </template>
    </v-list>
  </v-card>
</template>


<script>

import router from "@/router.js";
import { mapState } from "vuex";
import DashboardBar from "@/components/dashboard/DashboardBar.vue";

export default {
  name: 'IesHome',
  components: {
    DashboardBar,
  },
  data(){
    return {
      hover: false,
      loading: true,
      action_buttons:[
        {name:'init_register', text:'Comenzar registro', next_status:'in_register'},
        {name:'init_register', text:'Registrar avances', next_status:'in_register', is_middle: true},
        {name:'modify_data', text:'Corregir Información', next_status:'in_changes'},
        {name:'edit_data', text:'Continuar registro', action:'goTo'},
        {name:'restart_review', text:'Registrar avances', next_status:'in_register', is_middle: true}
      ],
    }
  },
  computed:{
    ...mapState({
      ies_data: state => state.ies_data,
      status_ies: state => state.status_ies,
    }),
    can_ies_modify(){
      return !this.period.register_referance.status.can_ies_change
    },
    periods_ies(){
      return this.ies_data ? this.ies_data.periods.map(period=>{
        period.st_detail = period.register_referance.status
        return period
      }) : []
    },
  },
  methods:{
    goTo(period_id){
      router.push({name: 'PeriodIes', params: {'period_ies_id': period_id}})
    },
    chooseButtons(period){
      return this.action_buttons.filter(btn=>{
        return period.st_detail.button_user == btn.name
          && period.actions_available >= 2
          && !btn.is_middle || period.stage == 'middle'
      })
    },
    indirectLogo(){
      document.getElementById("logo").click();
    },
    changeLogo(e){
      console.log(e)
      var file = e.target.files[0] || e.dataTransfer.files[0];
    
      let formData = new FormData();
      formData.append("logo", file, file.name);
      this.$store
        .dispatch('UPDATE_LOGO', {data:formData,
          university_id: this.ies_data.id, 
          snack_text: "Tu logo ha sido actualizado"})
        .then((data) => {
          console.log(data)
        })
        .catch(error =>
          console.log(error)
        );

    },
    needPreviousComplete(period){
      if (period.stage == 'middle')
        if (this.ies_data.periods.find(x=> x.year+1 == period.year 
            && x.register_referance.is_official && x.stage === 'final'))
          return false
        else
          return true
      else
        return false
    },
    hasPreviousYear(period){
      if (period.stage == 'final')
        return true
      else 
        if (!this.needPreviousComplete(period))
          return true
        else if (this.ies_data.periods.find(x=> 
            (x.year+1 == period.year && x.stage === 'middle') 
            || (x.year+1 == period.year && x.stage === 'final'
              && x.actions_available > 0) ))
          return true
        else return false
    },
    actionButton(btn, period_id){
      //console.log("antes de todo")
      //console.log(period_id)
      //console.log(btn)
      let action = btn.action ? btn.action : btn.name
      //console.log(action)
      /*if (action == 'register_advances'){
        console.log('avanzaré');
      }*/
      if (action == 'goTo'){
        this.goTo(period_id)
      }
      else if (action == 'init_register' ||  action == 'modify_data' || action == 'register_advances'){
        //console.log("soy init")
        //console.log(this.status_ies)
        let new_status = this.status_ies.find(d=>d.name == btn.next_status)
        this.$store
          .dispatch('UPDATE_PERIOD_IES_BASE', {
            data: {status_registro: new_status.id,
                  snack_text:'Ahora podrás registrar tus datos'}, 
            period_ies_id: period_id
          })
          .then((data) => {
            //console.log(data)
            this.goTo(period_id)
          })
          .catch(error =>
            console.log(error)
          );
        //
       
      }
    },
  },
  mounted(){
    this.loading = true;
    console.log("cargando GET_IES_DATA")
    this.$store.dispatch('GET_IES_DATA', router.currentRoute.params.ies_id)
      .then(()=>{
        this.loading = false;
      })
  }
}
</script>


<style lang="scss" scoped>
.header-with{
  max-width: 700px;
}
.width-actions{
  min-width: 240px;
}
</style>